// // Component Libraries
// import LandingNavBar from "../LandingNavBar/LandingNavBar";

// //Asset Libraries
// import { ReactComponent as AuthBackgroundImage } from "../../../assets/auth-landing-page-sign-in-content.svg";
// import { ReactComponent as AuthDelineator } from "../../../assets/auth-text-delineator.svg";
// import GoogleSignInButton from "../GoogleSignInButton/GoogleSignInButton";

// import "./SignIn.scss";

// //Function Libraries

// import { Link, useNavigate } from "react-router-dom";
// import { useState, useContext } from "react";

// import { UserContext } from "../../../model/contexts/user.context";

// import { signInUser } from "../../../api/users.api";
// import { useUser } from "../../../model/contexts/user.context";

// // import { loadUserProfile } from "../../../controller/firebase/firebase.utilities";

// //Form Data Initializer
// const defaultFormFields = {
//   email: "",
//   password: "",
// };

// const SignIn = () => {
//   const [formFields, setFormFields] = useState(defaultFormFields);
//   const { email, password } = formFields;
//   const [loading, setLoading] = useState(false);
//   const [isVerificationSent, setIsVerificationSent] = useState(false);

//   const navigate = useNavigate();
//   const { loginUser } = useContext(UserContext);

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (!email.trim()) {
//       alert("Please Input a Valid Email!");
//       return;
//     }

//     if (!password.trim()) {
//       alert("Please Input a Password!");
//       return;
//     }

//     if (!email.includes("@")) {
//       alert("Please make sure you input a valid email!");
//       return;
//     }

//     try {
//       const data = await signInUser({
//         email: email.trim(),
//         password,
//       });

//       const user = data.user;

//       if (!user) {
//         throw new Error("No user returned from sign-in.");
//       }

//       if (!user.isVerified) {
//         resetFormInput();
//         setIsVerificationSent(true);

//         setTimeout(() => {
//           setIsVerificationSent(false);
//           navigate("/auth");
//         }, 6000);

//         return;
//       }

//       loginUser(user);
//       resetFormInput();
//       navigate("/project-dashboard");
//     } catch (error) {
//       console.error("Sign in error:", error.response?.data || error.message);

//       alert(
//         error.response?.data?.error ||
//           error.message ||
//           "Invalid User Credentials! Check Your Input.",
//       );
//     }
//   };

//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setFormFields({ ...formFields, [name]: value });
//   };

//   const resetFormInput = () => {
//     setFormFields(defaultFormFields);
//   };

//   return (
//     <div className="auth-sign-in-container">
//       <LandingNavBar />
//       <div className="auth-sign-in-landing-content-container">
//         {!isVerificationSent ? (
//           <>
//             <div className="sign-in-welcome-content-container">
//               <p className="landing-content-font-v1 sign-in-text">
//                 Get Your Day Started
//               </p>
//               <p className="landing-content-font-v2 sign-in-text">Game Time</p>
//               {/* <AuthBackgroundImage className="auth-background-image" /> */}
//             </div>
//             <div className="auth-sign-in-form-outer-container">
//               <div className="auth-sign-in-form-inner-container">
//                 <div className="auth-main-login-container">
//                   <div className="auth-main-login-form-container">
//                     <div className="auth-form-item">
//                       <p className="auth-form-text"> Email</p>
//                       <input
//                         className="auth-form-input-field"
//                         type="email"
//                         required={true}
//                         name="email"
//                         onChange={handleChange}
//                         value={email}
//                       />
//                     </div>
//                     <div className="auth-form-item">
//                       <p className="auth-form-text"> Password </p>
//                       <input
//                         className="auth-form-input-field"
//                         type="password"
//                         required={true}
//                         name="password"
//                         onChange={handleChange}
//                         value={password}
//                       />
//                     </div>
//                     <div className="auth-form-item">
//                       <div className="auth-form-button" onClick={handleSubmit}>
//                         Sign In
//                       </div>
//                       <AuthDelineator className="auth-delineator" />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="auth-alternative-login-container">
//                   <div className="auth-alternative-login-inner-container">
//                     <div
//                       className="auth-google-sign-in-wrapper"
//                       data-testid="google-sign-in-wrapper"
//                     >
//                       <GoogleSignInButton
//                         mode="signin"
//                         resetFormInput={resetFormInput}
//                       />
//                     </div>
//                     <div className="auth-sign-in-alternative-text">
//                       If you do not have an account, please sign up
//                       <Link
//                         className="auth-sign-in-link-text"
//                         to="/auth/sign-up"
//                       >
//                         here
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           // Verification Message
//           <div className="sign-in-verification-message">
//             <h1>{"Almost there! 📩"}</h1>
//             <h2>
//               {
//                 "We just sent a verification email to your inbox. To keep things secure, you'll need to click the link in that email before signing in."
//               }
//             </h2>
//             <h2>
//               {
//                 "Can't find it? Give it a minute — and don't forget to check your spam or junk folder just in case it got lost on the way."
//               }
//             </h2>
//             <h2>
//               {
//                 "Once you're verified, come back here and sign in to access your account."
//               }
//             </h2>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SignIn;

import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import LandingNavBar from "../LandingNavBar/LandingNavBar";
import GoogleSignInButton from "../GoogleSignInButton/GoogleSignInButton";

import { ReactComponent as AuthDelineator } from "../../../assets/auth-text-delineator.svg";

import { UserContext } from "../../../model/contexts/user.context";
import { signInUser } from "../../../api/users.api";

import "./SignIn.scss";

const defaultFormFields = {
  email: "",
  password: "",
};

const SignIn = () => {
  const [formFields, setFormFields] = useState(defaultFormFields);
  const [loading, setLoading] = useState(false);
  const [isVerificationSent, setIsVerificationSent] = useState(false);

  const { email, password } = formFields;

  const navigate = useNavigate();
  const { loginUser } = useContext(UserContext);

  const resetFormInput = () => {
    setFormFields(defaultFormFields);
  };

  useEffect(() => {
    if (!isVerificationSent) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setIsVerificationSent(false);
      navigate("/auth");
    }, 6000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isVerificationSent, navigate]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormFields((currentFields) => ({
      ...currentFields,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
      alert("Please enter your email.");
      return;
    }

    if (!normalizedEmail.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    if (!password.trim()) {
      alert("Please enter your password.");
      return;
    }

    setLoading(true);

    try {
      const data = await signInUser({
        email: normalizedEmail,
        password,
      });

      const user = data?.user;

      if (!user) {
        throw new Error("No user was returned from sign-in.");
      }

      if (!user.isVerified) {
        resetFormInput();
        setIsVerificationSent(true);
        return;
      }

      loginUser(user);
      resetFormInput();
      navigate("/project-dashboard");
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "Invalid user credentials. Please check your information.";

      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sign-in-page">
      <LandingNavBar />

      <main className="sign-in-page__content">
        {!isVerificationSent ? (
          <>
            <section className="sign-in-page__welcome">
              <p className="sign-in-page__headline">Get Your Day Started</p>

              <p className="sign-in-page__subheadline">Game Time</p>
            </section>

            <section className="sign-in-page__panel">
              <div className="sign-in-page__card">
                <div className="sign-in-page__form-area">
                  <form
                    className="sign-in-page__form"
                    onSubmit={handleSubmit}
                    noValidate
                  >
                    <div className="sign-in-page__field">
                      <label
                        className="sign-in-page__label"
                        htmlFor="sign-in-email"
                      >
                        Email
                      </label>

                      <input
                        id="sign-in-email"
                        className="sign-in-page__input"
                        type="email"
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={handleChange}
                        disabled={loading}
                        required
                      />
                    </div>

                    <div className="sign-in-page__field">
                      <label
                        className="sign-in-page__label"
                        htmlFor="sign-in-password"
                      >
                        Password
                      </label>

                      <input
                        id="sign-in-password"
                        className="sign-in-page__input"
                        type="password"
                        name="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={handleChange}
                        disabled={loading}
                        required
                      />
                    </div>

                    <button
                      className="sign-in-page__submit"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Signing In..." : "Sign In"}
                    </button>

                    <div className="sign-in-page__divider">
                      <AuthDelineator
                        className="sign-in-page__divider-image"
                        aria-hidden="true"
                      />
                    </div>
                  </form>
                </div>

                <div className="sign-in-page__alternative-area">
                  <div className="sign-in-page__alternative-content">
                    <div className="sign-in-page__google-wrapper">
                      <GoogleSignInButton
                        mode="signin"
                        resetFormInput={resetFormInput}
                      />
                    </div>

                    <p className="sign-in-page__alternative-text">
                      If you do not have an account, please sign up{" "}
                      <Link className="sign-in-page__link" to="/auth/sign-up">
                        here
                      </Link>
                      .
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </>
        ) : (
          <section
            className="sign-in-page__verification"
            role="status"
            aria-live="polite"
          >
            <h1>Almost there! 📩</h1>

            <h2>
              We sent a verification email to your inbox. Click the link in that
              email before signing in.
            </h2>

            <h2>
              If you cannot find it, give it a minute and check your spam or
              junk folder.
            </h2>

            <h2>Once your account is verified, return here and sign in.</h2>
          </section>
        )}
      </main>
    </div>
  );
};

export default SignIn;
